import '../styles/gadgets.css';

export function SiteCounter () {
    return <div className='counter'>
        0000029
    </div>
}